/**
 * PlanLimitCallout — shown when the backend blocks a create action with a
 * 402 plan error. Pass the error from the failed request. Renders nothing
 * for any other error.
 */
import { Callout, Link } from '@radix-ui/themes';
import { Link as RouterLink } from 'react-router-dom';
import { planLimitFromError, type PlanLimitDetails } from '../../utils/billing';

interface Props {
  error?: unknown;
  details?: PlanLimitDetails | null;
}

const PlanLimitCallout: React.FC<Props> = ({ error, details }) => {
  const limit = details ?? planLimitFromError(error);
  if (!limit) return null;
  return (
    <Callout.Root color="amber" role="alert">
      <Callout.Text>
        {limit.message}{' '}
        <Link asChild weight="medium">
          <RouterLink to="/billing">See plans</RouterLink>
        </Link>
      </Callout.Text>
    </Callout.Root>
  );
};

export default PlanLimitCallout;
